import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import store from "./redux/store";
import { Provider, useSelector } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Provider store={store}> {/* -> REDUX PROVIDER */}
        <App />
    </Provider>
    // </React.StrictMode>
);

